@use '../../style/globals.scss' as *;

.NewsTicker {
    position: absolute;
    right: 0;
    bottom: 0;
    overflow: hidden;
    width: 469px;
    max-width: 100%;
    height: 70px;
    background: rgba(0, 0, 0, 0.3);
    font-size: $font-size-p;
    border-radius: 20px 20px 0px 0px;
    pointer-events: none;
    transition: transform 200ms linear, opacity 200ms linear;
    opacity: 1;

    // Fixes issue where hidden class is buggy on iPhone
    will-change: transform;
    -webkit-backface-visibility: hidden;
    -webkit-transform: translateZ(0);

    &.hasLowerTransparency {
        background: rgba(0, 0, 0, 0.1);
    }

    &.hidden {
        transform: translateY(100%);
        opacity: 0;
    }

    @media (max-width: $bp-xs) {
        height: 50px;
        border-radius: 15px 15px 0px 0px;
    }
}
